// extracted by mini-css-extract-plugin
export default {"settings":"iL0wrUBNON5VcjViKp3w","container":"CUIH4rUph43yo85SBYF5"};